import { getApiUrl } from '../../util/api/api'
import type { UpdateDefaultLogoAction } from '../../../state/actions/user/user'

const updateDefaultlogo = async (action: UpdateDefaultLogoAction) => {
  const response = await fetch(
    getApiUrl('/dashboard/api/recruiter/company/logo'), {
      method: 'PUT',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ defaultCompanyLogo: { key: action.payload } }),
      mode: 'cors',
    }
  )
  
  if (response?.ok) {
    const responseJson = await response.json()
    return Promise.resolve({ status: response.status, data: responseJson})
  } else {
    return Promise.reject(response ? { status: response.status, data: response.statusText } : null)
  }
}

export default updateDefaultlogo
